<kendo-card class="val-carte" width="auto">
  <ng-content />
</kendo-card>
